<template>
  <div v-if="user.roles && (user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.FUTURES) || userHasResourceAccess(RESOURCENAMES.MANAGEMENT))">
    <iframe src="https://awspro01.dynamicodds.com/admin/control_panel/new/dashboard.php?mode=futures"
    width="100%" 
    height="1000" 
    style="margin-top: 35px; border:1px solid black;">
    </iframe>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { accessControlMixin } from '../components/mixins/index'

export default {
  mixins:[accessControlMixin],
  data () {
    return {}
  },
  mounted () {
    if (this.user.roles && (!this.user.roles.includes('*') && !this.userHasResourceAccess(this.RESOURCENAMES.FUTURES) && !this.userHasResourceAccess(this.RESOURCENAMES.MANAGEMENT))) {
      if (this.$route && this.$route.path !== '/') {
        this.$router.push('/')
      }
    }
  },
  computed: {
    ...mapGetters(['getUserLoggedIn']),
    user () {
      return this.getUserLoggedIn
    }
  }
}
</script>
